import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-scene-action-menu',
    templateUrl: './scene-action-menu.component.html',
    //    styleUrls: ['./scene-action-menu.component.scss']
})
export class SceneActionMenuComponent implements OnChanges {
    @Input() sceneactiontop: string;
    @Input() sceneactionleft: string;
    @Input() sceneactionvisible: boolean;
    @Input() sceneactionmenuvisible: boolean;
    @Input() curSelectedRow: number;
    @Input() outputrow: number;
    @Input() project: any;
    @Input() contextmenuitem: number;
    @Input() contextmenuitem1: number;
    @Input() sheetid: number;
    @Input() menustyle: string = 'default';

    @Output() addGuiEvent = new EventEmitter<{ type: string, insertLocation: 'outputrow' }>();
    @Output() addPrimitiveEvent = new EventEmitter<{ type: string, insertLocation: 'outputrow' }>();
    @Output() showfilesDialogEvent = new EventEmitter<any>();
    @Output() addProjectEvent = new EventEmitter<void>();
    @Output() exportSceneEvent = new EventEmitter<void>();
    @Output() openInsertObjectDialogEvent = new EventEmitter<void>();
    @Output() toggleMenuEvent = new EventEmitter<void>();

    showOverlaymenu1 = false;
    showSheetsmenu = false;
    showOverlaymenu = false;
    showothermenu = false;

    // Grid menu state
    activeGridTab: 'controls' | 'objects' = 'controls';

    // Pagination properties
    currentControlPage = 0;
    currentObjectPage = 0;
    itemsPerPage = 8;

    // Control items configuration
    controlItems = [
        { title: 'Label', icon: 'fa fa-tags', action: () => this.addGui('label') },
        { title: 'Textbox', icon: 'fa fa-edit', action: () => this.addGui('textbox') },
        { title: 'Number', icon: 'fa fa-calculator', action: () => this.addGui('number') },
        { title: 'Checkbox', icon: 'fa fa-check-square', action: () => this.addGui('checkbox') },
        { title: 'Radio', icon: 'fa fa-dot-circle', action: () => this.addGui('radio') },
        { title: 'Image', icon: 'fa fa-image', action: () => this.showfilesDialog('png') },
        { title: 'Select', icon: 'fa fa-list', action: () => this.addGui('select') },
        { title: 'Slider', icon: 'fa fa-sliders', action: () => this.addGui('slider') },
        { title: 'Button', icon: 'fa fa-hand-pointer', action: () => this.addGui('button') },
        { title: 'Color Chooser', icon: 'fa fa-palette', action: () => this.addGui('colorchooser') },
        { title: 'Color Palette', icon: 'fa fa-palette', action: () => this.addGui('colorchooser (predefined palette)') },
        { title: 'Custom Color Set', icon: 'fa fa-palette', action: () => this.addGui('colorchooser (custom colors)') },
        { title: 'HTML', icon: 'fa fa-code', action: () => this.addGui('html') },
        { title: 'Save Button', icon: 'fa fa-save', action: () => this.addGui('savebutton') },
        { title: 'Export Button', icon: 'fa fa-download', action: () => this.addGui('exportbutton') },
        { title: 'Timer', icon: 'fa fa-clock', action: () => this.addGui('timer') }
    ];

    // Object items configuration
    objectItems = [
        // Main objects
        { title: 'Extrusion', icon: 'fa fa-cube', action: () => this.addPrimitive('extrusion'), category: 'main' },
        { title: '3D File', icon: 'fa fa-file-archive', action: () => this.showfilesDialog('gltf'), category: 'main' },
        { title: 'Line', icon: 'fa fa-minus', action: () => this.addPrimitive('line'), category: 'main' },
        { title: 'Dimension Line', icon: 'fa fa-ruler', action: () => this.addPrimitive('dimensionline'), category: 'main' },
        { title: 'Shape', icon: 'fa fa-star', action: () => this.addPrimitive('shape'), category: 'main' },
        { title: 'Cube', icon: 'fa fa-square', action: () => this.addPrimitive('cube'), category: 'main' },
        { title: 'Cylinder', icon: 'fa fa-circle', action: () => this.addPrimitive('cylinder'), category: 'main' },
        { title: 'I-Beam', icon: 'fa fa-industry', action: () => this.addPrimitive('ibeam'), category: 'main' },
        { title: 'Image', icon: 'fa fa-image', action: () => this.showfilesDialog('png', false, true), category: 'main' },
        { title: 'Text Flat', icon: 'fa fa-font', action: () => this.addPrimitive('textflat'), category: 'main' },
        { title: 'Project', icon: 'fa fa-folder-open', action: () => this.openInsertObjectDialog(), category: 'project' },

        // Other objects
        //    { title: 'Union', icon: 'fa fa-plus-square', action: () => this.addPrimitive('union'), category: 'other' },
        { title: 'Sphere', icon: 'fa-solid fa-globe', action: () => this.addPrimitive('sphere'), category: 'other' },
        { title: 'Capsule', icon: 'fa fa-capsules', action: () => this.addPrimitive('capsule'), category: 'other' },
        { title: 'Ring', icon: 'fa fa-ring', action: () => this.addPrimitive('ring'), category: 'other' },
        //  { title: 'Surface', icon: 'fa fa-mountain', action: () => this.addPrimitive('surface'), category: 'other' },
        { title: 'Light', icon: 'fa-solid fa-lightbulb', action: () => this.addPrimitive('light'), category: 'other' },
        { title: 'Profile', icon: 'fa fa-bezier-curve', action: () => this.addPrimitive('profile'), category: 'other' },
        { title: 'Grid', icon: 'fa fa-th-large', action: () => this.addPrimitive('grid'), category: 'other' },
        { title: 'Arrow', icon: 'fa fa-arrow-right', action: () => this.addPrimitive('arrow'), category: 'other' },
        { title: 'Tube', icon: 'fa-solid fa-grip-lines', action: () => this.addPrimitive('tube'), category: 'other' },
        { title: 'Spring', icon: 'fa-solid fa-water', action: () => this.addPrimitive('spring'), category: 'other' },
        { title: 'Subtraction', icon: 'fa fa-minus-square', action: () => this.addPrimitive('subtraction'), category: 'other' },
        { title: 'Connector', icon: 'fa fa-plug', action: () => this.addPrimitive('connector'), category: 'other' },

        // Overlay objects
        //    { title: 'Text 2D', icon: 'fa fa-text-width', action: () => this.addPrimitive('text2d'), category: 'overlay' },
        //    { title: 'Rectangle 2D', icon: 'fa fa-square-o', action: () => this.addPrimitive('rectangle2d'), category: 'overlay' },
        //   { title: 'Overlay HTML', icon: 'fa fa-code', action: () => this.addPrimitive('overlayhtml'), category: 'overlay' }
    ];

    ngOnChanges(changes: SimpleChanges) {
        // Check if sceneactionmenuvisible changed
        console.log('onchanges sceneactionmenuvisible', this.sceneactionmenuvisible, changes);

        if (changes?.sceneactionvisible?.currentValue == false) {
            this.hideallsubmenus();
            this.sceneactionmenuvisible = false;
        }

        // Set default tab for grid menu
        if (this.curSelectedRow > this.outputrow) {
            this.activeGridTab = 'objects';
        } else {
            this.activeGridTab = 'controls';
        }
    }

    addGui(type: string) {
        this.addGuiEvent.emit({ type, insertLocation: 'outputrow' });
    }

    addPrimitive(type: string) {
        this.addPrimitiveEvent.emit({ type, insertLocation: 'outputrow' });
    }

    showfilesDialog(type: string, arg2?: boolean, arg3?: boolean) {
        this.showfilesDialogEvent.emit({ type, arg2, arg3 });
    }

    addProject() {
        this.addProjectEvent.emit();
    }

    openInsertObjectDialog() {
        this.openInsertObjectDialogEvent.emit();
    }

    showhidemenu() {
        // Emit event to parent component to toggle menu visibility
        this.toggleMenuEvent.emit();
        console.log('showhidemenu - emitting toggle event for scene action menu');

        // If the menu is about to be shown, check its position
        if (!this.sceneactionmenuvisible) {
            this.hideallsubmenus();

            // Use setTimeout to allow the DOM to update before we measure elements
            setTimeout(() => {
                if (this.menustyle === 'grid') {
                    // this.adjustGridPanelPosition(); // No longer needed
                } else {
                    // Existing logic for other menus
                    const windowHeight = window.innerHeight;
                    const menuElement = document.querySelector('.scene-action-menu') as HTMLElement;
                    if (!menuElement) return;

                    const menuHeight = menuElement.offsetHeight;
                    const top = parseInt(this.sceneactiontop.replace('px', ''));
                    const wouldGoOffScreen = (top + menuHeight) > windowHeight;

                    if (wouldGoOffScreen) {
                        this.sceneactiontop = (top - menuHeight - 10) + 'px';
                    }
                    // No need for an else, as the original position is the default
                }
            }, 0);
        }
    }

    hideallsubmenus() {
        this.showOverlaymenu1 = false;
        this.showSheetsmenu = false;
        this.showOverlaymenu = false;
        this.showothermenu = false;
    }

    exportScene() {
        this.exportSceneEvent.emit();
    }

    // Pagination methods for controls
    get totalControlPages(): number {
        return Math.ceil(this.controlItems.length / this.itemsPerPage);
    }

    getCurrentControlItems() {
        const startIndex = this.currentControlPage * this.itemsPerPage;
        return this.controlItems.slice(startIndex, startIndex + this.itemsPerPage);
    }

    nextControlPage() {
        this.currentControlPage = (this.currentControlPage + 1) % this.totalControlPages;
    }

    // Pagination methods for objects
    get totalObjectPages(): number {
        const allObjectItems = this.getAllObjectItems();
        return Math.ceil(allObjectItems.length / this.itemsPerPage);
    }

    getCurrentObjectItems() {
        const allObjectItems = this.getAllObjectItems();
        const startIndex = this.currentObjectPage * this.itemsPerPage;
        return allObjectItems.slice(startIndex, startIndex + this.itemsPerPage);
    }

    // Get all object items including dynamic sheet items
    getAllObjectItems() {
        const sheetItems = this.getSheetItems();
        return [...this.objectItems, ...sheetItems];
    }

    get mainObjectItems() {
        return this.objectItems.filter(item => item.category === 'main');
    }

    get otherObjectItems() {
        return this.objectItems.filter(item => item.category === 'other');
    }

    get projectObjectItem() {
        return this.objectItems.find(item => item.category === 'project');
    }

    get overlayObjectItems() {
        return this.objectItems.filter(item => item.category === 'overlay');
    }

    // Generate dynamic sheet items
    getSheetItems() {
        if (!this.project?.sheets) return [];

        return this.project.sheets
            .map((sheet: any, index: number) => {
                if (index > 0) { // Skip first sheet (main sheet)
                    return {
                        title: `Sheet: ${sheet.name}`,
                        icon: 'fa fa-table',
                        action: () => this.addPrimitive(`sheet: ${sheet.name}`)
                    };
                }
                return null;
            })
            .filter((item: any) => item !== null);
    }

    nextObjectPage() {
        this.currentObjectPage = (this.currentObjectPage + 1) % this.totalObjectPages;
    }

    // Helper method to calculate circular positions
    getCircularPosition(index: number, totalItems: number): { top: string, left: string } {
        const centerX = 30;
        const centerY = 30;
        const radius = 80;
        const angleStep = (2 * Math.PI) / Math.min(totalItems, this.itemsPerPage);
        const angle = index * angleStep - (Math.PI / 2); // Start from top (12 o'clock)

        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        return {
            top: `${y}px`,
            left: `${x}px`
        };
    }
} 